
export default {
  inject: ['product', 'wording'],
  data() {
    return {
      product: this.product,
      wording: this.wording,
      toggled: false,
    }
  },
  computed: {
    fittingGuideIndicator() {
      switch (this.product?.fitting_guide) {
        case 'runs_small_size_up':
          return 'left'
        case 'between_small_true':
          return 'middle-left'
        case 'true_to_size':
          return 'center'
        case 'between_large_true':
          return 'middle-right'
        case 'runs_large_size_down':
          return 'right'
        default:
          return null
      }
    },
    fittingGuideLabel() {
      switch (this.product?.fitting_guide) {
        case 'runs_small_size_up':
          return this.wording.fitting_guide_runs_small_size_up
        case 'between_small_true':
          return this.wording.fitting_guide_between_small_true
        case 'true_to_size':
          return this.wording.fitting_guide_true_to_size
        case 'between_large_true':
          return this.wording.fitting_guide_between_large_true
        case 'runs_large_size_down':
          return this.wording.fitting_guide_runs_large_size_down
        default:
          return null
      }
    },
  },
}
